<script>
import ListingModel from "@/views/Request/Claim/Components/ListingModel.vue";
export default {
    components: {ListingModel}
}
</script>

<template>
    <listing-model type="ADMIN_REQUEST" intranet/>
</template>